import templateUrl from "emun.customer/customer-change-id.htm";
import open from "webmodals/open";
import modals from "webmodals/modals";
import ServiceBus from 'servicestack/service-bus'
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import customerConfig from "emun.customer/customer.config";

class controller {
  constructor($scope, options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.customerConfig = customerConfig;
    $ctrl.bus = $ctrl.$session.bus;
      $ctrl.title = options.title || " Change ID...";
      $ctrl.retailer = options.retailer || {};
    $ctrl.request = {
      OldId: $ctrl.retailer.id,
      NewId: ""
    };
    $ctrl.submit = () => {
		$ctrl.bus.send("ChangeRetailerId.json", $ctrl.request).then(res => {
			$ctrl.$close({ updated: $ctrl.request.NewId });
		});
    };
  }

  findRetailers(val) {
    const $ctrl = this;
    var search = encodeURIComponent(val);
    //console.info("decode", search);
    //console.info("encode", encodeURIComponent(val))
    let url = `QueryRetailers.json?Take=25&Status=Active&Search=${search}&OrderBy=CompanyName`; //
    return $ctrl.bus
      .send(url, {
        op: "ChangeRetailerId",
      })
      .then((res) =>
        res.data.results.map((retailer) =>
          Object.assign(retailer, { config: cartConfig })
        )
      );
  }

  selectRetailer(val) {
    const $ctrl = this;
    var retailerChanged = false;

    $ctrl.request.retailer = val;
    $ctrl.request.NewId = val.id;

  }

}

export default {
  open(options) {
    return modals.open(
      Object.assign(
        {
          templateUrl,
          resolve: {
            options: () => options
          },
          bindToController: true,
          controller,
          controllerAs: "$ctrl",
          size: "md"
        },
        (options || {}).modal
      )
    ).result;
  }
};

